module.exports = __webpack_public_path__ + "static/material-badge-count-9a93de1604100b5a2280ae8e63cc5e6d.png";